import React, { useEffect, useState } from "react";
import { IoCloseOutline } from "react-icons/io5";
import { FaTelegramPlane, FaPhoneAlt, FaComments } from "react-icons/fa";
import { getEmergencyContacts } from "../../../Api/emergencyContactsApi";
import { getSocialMediaLinks } from "../../../Api/socialMediaLinkApi";

function FloatingWidgets() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [callOpen, setCallOpen] = useState(false);
  const [chatOpen, setChatOpen] = useState(false);
  const [contacts, setContacts] = useState([]);
  const [telegramLink, setTelegramLink] = useState("");
  const [showWidget, setShowWidget] = useState(false);

  // Show widget only after scroll
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 250) {
        setShowWidget(true);
      } else {
        setShowWidget(false);
        setMenuOpen(false);
        setCallOpen(false);
        setChatOpen(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  // Fetch contacts
  useEffect(() => {
    const fetchContacts = async () => {
      try {
        const res = await getEmergencyContacts();
        setContacts(res.data || res || []);
      } catch {
        setContacts([]);
      }
    };
    fetchContacts();
  }, []);

  // Fetch telegram link
  useEffect(() => {
    const fetchSocialLinks = async () => {
      try {
        const res = await getSocialMediaLinks();
        const links = res.data || res || [];
        const telegram = links.find(
          (link) => link.platform?.toLowerCase() === "telegram"
        );
        setTelegramLink(telegram?.url || null);
      } catch {
        setTelegramLink(null);
      }
    };
    fetchSocialLinks();
  }, []);

  // ❗ Hide the widget if NO contacts AND NO telegram link
  const noData = contacts.length === 0 && !telegramLink;

  // Final gate
  if (!showWidget || noData) return null;

  return (
    <div className="fixed bottom-32 right-6 z-[9999] flex flex-col-reverse items-end animate-fade-in">
      {/* Chat Popup */}
      {chatOpen && telegramLink && (
        <div className="mb-2 w-72 bg-white rounded-lg shadow-xl border overflow-hidden animate-slide-up">
          <div className="flex justify-between items-center bg-Dark text-white px-3 py-2">
            <span className="font-semibold">Chat with us</span>
            <button
              onClick={() => setChatOpen(false)}
              className="hover:text-gray-200 transition"
            >
              <IoCloseOutline size={22} />
            </button>
          </div>
          <div className="p-3 text-sm text-gray-700">
            👋 Need help? Start a conversation on Telegram.
          </div>
          <div className="p-3 border-t flex justify-end">
            <a
              href={telegramLink}
              target="_blank"
              rel="noopener noreferrer"
              className="bg-Dark hover:bg-Dark/80 text-white px-4 py-1 rounded text-sm flex items-center gap-2 transition"
            >
              <FaTelegramPlane /> Open Telegram
            </a>
          </div>
        </div>
      )}

      {/* Call Popup */}
      {callOpen && contacts.length > 0 && (
        <div className="mb-2 w-72 bg-white rounded-lg shadow-xl border overflow-hidden animate-slide-up">
          <div className="flex justify-between items-center bg-Dark text-white px-3 py-2">
            <span className="font-semibold">Emergency Contacts</span>
            <button
              onClick={() => setCallOpen(false)}
              className="hover:text-gray-200 transition"
            >
              <IoCloseOutline size={22} />
            </button>
          </div>
          <div className="p-3 max-h-48 overflow-y-auto">
            <ul className="space-y-2">
              {contacts.map((c, idx) => (
                <li key={idx} className="flex items-center gap-2">
                  <FaPhoneAlt className="text-Dark" />
                  <a
                    href={`tel:${c.phone}`}
                    className="text-Dark hover:underline text-sm"
                  >
                    {c.phone}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>
      )}

      {/* Floating Main Button */}
      <div className="relative flex flex-col items-center">
        <button
          onClick={() => setMenuOpen((prev) => !prev)}
          className="bg-Light text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
          title="Contact Options"
        >
          {menuOpen ? (
            <IoCloseOutline size={24} className="text-white" />
          ) : (
            <FaComments size={24} className="text-white" />
          )}
        </button>

        {/* Only show sub-icons that have data */}
        {menuOpen && (
          <div className="absolute bottom-16 right-0 flex flex-col gap-3 items-end animate-slide-up">
            {telegramLink && (
              <button
                onClick={() => {
                  setChatOpen((prev) => !prev);
                  setCallOpen(false);
                }}
                className="bg-Dark hover:bg-Dark/80 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
                title="Chat on Telegram"
              >
                <FaTelegramPlane size={22} />
              </button>
            )}

            {contacts.length > 0 && (
              <button
                onClick={() => {
                  setCallOpen((prev) => !prev);
                  setChatOpen(false);
                }}
                className="bg-Dark hover:bg-Dark/80 text-white w-14 h-14 rounded-full flex items-center justify-center shadow-lg hover:scale-110 transition-transform"
                title="Emergency Contacts"
              >
                <FaPhoneAlt size={22} />
              </button>
            )}
          </div>
        )}
      </div>
    </div>
  );
}

export default FloatingWidgets;
